import * as React from 'react'
import styled, { css } from 'styled-components'
import theme from 'theme'
import CartIcon from 'assets/cart.svg'
import useAccount from 'hooks/account/useAccount'
import Button from 'theme/atoms/Button'
import useTranslations from 'hooks/useTranslations'

export default function EmptyCart() {
  const t = useTranslations<'templates-Cart'>()
  const account = useAccount()
  return (
    <Wrapper className="EmptyCart">
      <div className="title">
        <CartIcon />
        <h2>{t('no_items_text')}</h2>
      </div>

      {!account.loggedIn && (
        <p data-cy-state="logged-out:show-text">{t('info_not_logged_in')}</p>
      )}
      {account.loggedIn && (
        <p data-cy-state="show-logged-in-text">{t('cart_shop_variety_text')}</p>
      )}

      <ButtonList $single={account.loggedIn}>
        {!account.loggedIn && (
          <Button
            label={t('account_signIn')}
            variation="primary"
            to="/account/"
            data-cy-state="logged-out:show-login-btn"
          />
        )}
        <Button
          label={t('continue_shopping')}
          variation={account.loggedIn ? 'primary' : 'secondary'}
          to="/"
        />
      </ButtonList>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: ${theme.spacing('m')};
  background: ${theme.colors.shade.b7};

  > .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing('s')};
    margin-bottom: ${theme.spacing('m')};
    @media (min-width: ${theme.ms.MD}px) {
      flex-direction: row;
      gap: ${theme.spacing('ml')};
    }

    > svg {
      min-width: 40px;
      height: 40px;
      g {
        fill: ${theme.colors.b0};
      }
    }
    > h2 {
      ${theme.ty('rc-3xl', 'bold')}
      @media(min-width: ${theme.ms.MD}px) {
        ${theme.ty('rc-4xl', 'bold')}
      }
    }
  }

  > p {
    margin: 0;
    ${theme.ty('r-s')}
    margin-bottom: ${theme.spacing('m')};
    @media (min-width: ${theme.ms.MD}px) {
      ${theme.ty('r-base')}
    }
  }
`

const ButtonList = styled.div<{ $single: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing('xs')};
  @media (min-width: ${theme.ms.MD}px) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  ${(p) =>
    !p.$single &&
    css`
      > .Button {
        flex: 1;
      }
    `}
`
